module.exports = __webpack_public_path__ + "img/icon-play2.12dcf7c6.png";